__webpack_require__.p = "/bizx-pos/potlatch/";